import React from 'react';
import { ContactFormBlock } from 'patterns/ContactFormBlock';
import { Masthead } from 'patterns/Masthead';
import { Shell } from 'patterns/Shell';
import { TestimonialListBlock } from 'patterns/TestimonialListBlock';

import '../scss/main.scss';

function ContactPage({
    location: {
        pathname,
        state,
    },
}) {
    const data = {
        masthead: {
            title: 'Hire me',
            description: [
                {
                    spans: [{
                        start: 68,
                        end: 84,
                        type: "hyperlink",
                        data: {
                            link_type: "Web",
                            url: "mailto:hello@robsimpson.digital?subject=New project enquiry",
                        },
                    }],
                    text: 'For new work inquiries please use the form below or if you’d prefer send me an email',
                    type: 'paragraph',
                },
            ],
            image: {
                alt: '',
                dimensions: {
                    height: 1920,
                    width: 2560,
                },
                url: 'https://images.prismic.io/robsimpson/8188348e-55c8-4572-82ed-f96701e83e6e_contact.jpg?auto=compress,format'
            },
        },
        testimonials: {
            background: false,
            description: 'Hearing how happy my clients are is the best part of what I do.',
            items: [
                {
                    testimonial_bio: {
                        text: 'Co-Founder at Howl',
                    },
                    testimonial_image: {
                        alt: '',
                        dimensions: {
                            height: 192,
                            width: 192,
                        },
                        url: 'https://images.prismic.io/robsimpson/c4375679-f583-43e4-812c-cb23c567318b_david-laub.png?auto=compress,format'
                    },
                    testimonial_quote: {
                        text: 'Rob has a unique ability to understand user experience needs, produce aesthetically pleasing designs, and write maintainable / modular code. To anyone in search of a highly creative and experienced developer for their next project - look no further.',
                    },
                    testimonial_name: {
                        text: 'David Laub',
                    },
                },
                {
                    testimonial_bio: {
                        text: 'Programme Manager at Dashboard',
                    },
                    testimonial_image: {
                        alt: '',
                        dimensions: {
                            height: 192,
                            width: 192,
                        },
                        url: 'https://images.prismic.io/robsimpson/c3f1228e-06a6-4599-9138-3e75e4fb6911_bryon-lowen.png?auto=compress,format'
                    },
                    testimonial_quote: {
                        text: 'We are delighted with the outcome. It is a step-change from our previous website, and we can highly recommend Rob for his approach / web technology expertise / and all-around delivery.',
                    },
                    testimonial_name: {
                        text: 'Bryon Lowen',
                    },
                },
            ],
            itemsPerRow: '2',
            title: 'Client success stories',
        },
    };
    const defaultService = (state) ? state.service : '';

    return (
        <Shell
            pageDescription="Contact me about a Jamstack marketing or eCommerce website."
            pageSocialImage=""
            pageTitle="Contact"
            pathname={pathname}
        >
            <Masthead
                description={data.masthead.description}
                image={data.masthead.image}
                title={data.masthead.title}
            />
            <ContactFormBlock background={true} defaultService={defaultService} />
            <TestimonialListBlock
                background={data.testimonials.background}
                description={data.testimonials.description}
                items={data.testimonials.items}
                itemsPerRow={data.testimonials.itemsPerRow}
                title={data.testimonials.title}
            />
        </Shell>
    );
}

export default ContactPage;
